import React, { useState } from "react";
import { FaPlay } from "react-icons/fa";
import bannerBgImage from "@/assets/images/ai-tools/chat-with-pdf/demo-bg-banner.svg";
import CommonButton from "@/components/common/CommonButton";
import CommonVideoButton from "@/components/common/CommonVideoButton";

const PdfDemo = () => {
  const [isPlaying, setIsPlaying] = useState(false);

  const handleClick = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const handlePlay = () => {
    setIsPlaying(true);
  };

  return (
    <div className="container py-8 xl:py-12">
      <div className="mx-auto flex flex-col items-center">
        <div
          className="relative flex aspect-video w-full min-w-[400px] items-center justify-center overflow-hidden rounded-2xl bg-cover bg-center bg-no-repeat"
          style={{ backgroundImage: `url(${bannerBgImage.src})` }}
        >
          {!isPlaying && (
            <button
              className="z-10 flex h-16 w-16 items-center justify-center rounded-full bg-white shadow-md transition-transform hover:scale-105"
              onClick={handlePlay}
            >
              <FaPlay className="ml-1 text-xl text-[#4436c7]" />
            </button>
          )}
          {isPlaying && (
            <iframe
              className="absolute inset-0 h-full w-full"
              src="https://www.youtube.com/embed/x7tZzLAo9uA?autoplay=1"
              title="PDF Demo Video"
              allow="autoplay; encrypted-media"
              allowFullScreen
            ></iframe>
          )}
        </div>
        <div className="mt-8 flex flex-col gap-4 sm:flex-row">
          <button
            onClick={handlePlay}
            className="rounded-[4px] bg-[#6049E7] px-6 py-2 text-white transition-colors hover:bg-[#553ED0]"
          >
            Try Demo
          </button>
          <button
            onClick={handleClick}
            className="rounded-md border border-black px-6 py-1.5 transition-colors hover:bg-gray-100"
          >
            Chat with PDF
          </button>
        </div>
      </div>
    </div>
  );
};

export default PdfDemo;
